import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation CreateZone($input: ZoneInput!, $tenantId: ID!) {
    tenant(id: $tenantId) {
      createZone(input: $input) {
        alias
        id
        code
        description
        name
        createdBy
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.nonNull(
  graphql.transformers.OUT.select<
    graphql.schema.CreateZoneMutation,
    ents.core.admin.Zone,
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'createZone',
      graphql.transformers.OUT.object({
        alias: graphql.transformers.OUT.validate(
          transformers.PASS_THROUGH,
          TypeAsserter.assertIsNotNullish,
          { warnOnly: true },
        ),
        code: graphql.transformers.OUT.validate(
          transformers.PASS_THROUGH,
          TypeAsserter.assertIsNotNullish,
          { warnOnly: true },
        ),
        description: transformers.PASS_THROUGH,
        createdBy: transformers.PASS_THROUGH,
        id: graphql.transformers.OUT.validate(
          transformers.PASS_THROUGH,
          TypeAsserter.assertIsNotNullish,
          { warnOnly: true },
        ),
        name: graphql.transformers.OUT.validate(
          transformers.PASS_THROUGH,
          TypeAsserter.assertIsNotNullish,
          { warnOnly: true },
        ),
      }),
    ),
  ),
)

export const executor = graphql.createExecutor<
  graphql.schema.CreateZoneMutation,
  ents.core.admin.Zone,
  graphql.schema.CreateZoneMutationVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
